<template>
	<div>
		<Toptab />
		<img class="newsbanner" src="../assets/img/newsbanner.jpg">
		<div class="newbox container">
			<div class="row pro-row" v-for="(item, index) in newestdata" :key="item.id">
				<div class="col-md-6 pro-img">
					<img :src="item.img">
				</div>
				<div class="col-md-6">
					<div class="newsdes">
						<router-link class="new-link" :to="{name:'New', params: {id: item.id}}">{{item.title}}</router-link>
						<p>{{item.text}}</p>
						<p class="time">{{item.time}}</p>
					</div>
				</div>
			</div>
		</div>
		
		<div class=" container">
			<div class="row new-row" v-for="(item, index) in newslist" :key="item.id">
				<div class="col-md-2 col-xs-3 new-img">
					<img  :src="item.img">
				</div>
				<div class="col-md-10 col-xs-9 new-rig">
					<div class="newsdes">
						<router-link :to="{name:'New',params:{id:item.id}}" >
							<h5>{{item.title}}</h5>
							<p class="newtext">
								{{item.text}}
							</p>
							<p>{{item.time}}</p>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<!-- <article  v-for="(item, index) in newslist" :key="item.id">
			<dl class="newslist">
				<dt>
					<div>
						<img :src="item.img">
					</div>
				</dt>
				<dd>
					<router-link :to="{name:'New',params:{id:item.id}}" >
						<h5>{{item.title}}</h5>
						<p class="newtext">
							{{item.text}}
						</p>
						<p class="time">{{item.time}}</p>
					</router-link>

				</dd>
			</dl>

		</article> -->
		<Footbar />
	</div>
</template>

<script>
	import Toptab from '../components/toptab.vue'
	import Footbar from "../components/footbar.vue"
	import "../assets/js/jquery-1.11.0.min.js"
	export default {
		components: {
			Toptab,
			Footbar
		},
		data() {
			return {
				newestdata: [{
					img: require("../assets/img/proapp01.jpg"),
					id: "222",
					title: "中国人民大学代驾司机",
					text: "发 i 好的啦大家啦睡觉的卡拉斯京都很粗寒窗苦读是插科打诨机场等一个地方给客户卡的何处回复苦厄位哈佛 i 核动力视力恢复对话窗口圣诞节的色彩",
					time: "四小时前更新"
				}, {
					img: require("../assets/img/proapp01.jpg"),
					id: "111",
					title: "中国人民大学代驾司机",
					text: "发 i 好的啦大家啦睡觉的卡拉斯京都很粗寒窗苦读是插科打诨机场等一个地方给客户卡的何处回复苦厄位哈佛 i 核动力视力恢复对话窗口圣诞节的色彩",
					time: "四小时前更新"
				}],
				newslist: [{
					img: require("../assets/img/abt-1.png"),
					id: "333",
					title: "中国人民大学代驾司机",
					text: "发 i 好的啦大家啦睡觉的卡拉斯京都很粗寒窗苦读是插科打诨机场等一个地方给客户卡的何处回复苦厄位哈佛 i 核动力视力恢复对话窗口圣诞节的色彩",
					time: "四小时前更新"
				}, {
					img: require("../assets/img/abt-1.png"),
					id: "444",
					title: "中国人民大学代驾司机",
					text: "发 i 好的啦大家啦睡觉的卡拉斯京都很粗寒窗苦读是插科打诨机场等一个地方给客户卡的何处回复苦厄位哈佛 i 核动力视力恢复对话窗口圣诞节的色彩",
					time: "四小时前更新"
				}, ]
			}
		},
		mounted() {

			// $.ajax({
			// 		type: "get", //请求方式
			// 		dataType: 'json', //数据格式
			// 		url: //请求地址
			// data: {
			// 	"ss": getCookie('openid') //请求参数  openid
			// },
			// success: function(data) {
			// 	console.log(data)
			// this.data.newestdata=data.data

			// let newslist2 = [{
			// 	img: "../assets/img/abt-1.png",
			// 	id: "333",
			// 	title: "中国人民大学代驾司机",
			// 	text: "发 i 好的啦大家啦睡觉的卡拉斯京都很粗寒窗苦读是插科打诨机场等一个地方给客户卡的何处回复苦厄位哈佛 i 核动力视力恢复对话窗口圣诞节的色彩",
			// 	time: "四小时前更新"
			// },{
			// 	img: "../assets/img/abt-1.png",
			// 	id: "333",
			// 	title: "中国人民大学代驾司机",
			// 	text: "发 i 好的啦大家啦睡觉的卡拉斯京都很粗寒窗苦读是插科打诨机场等一个地方给客户卡的何处回复苦厄位哈佛 i 核动力视力恢复对话窗口圣诞节的色彩",
			// 	time: "四小时前更新"
			// }, ]

			// var news = '';
			// console.log($("main"))
			// $.each(newslist2, function(c, t) {

			// 	news +=
			// 		`<dl class="newslist">
			// 	<dt><div><img src=${newslist[c].img}></div></dt>
			// 	<dd>
			// 		<a href=./new?id=${newslist[c].id}>
			// 			<h5>${newslist[c].title}</h5>
			// 			<p>${newslist[c].text}</p>
			// 			<p class="time">${newslist[c].time}</p>
			// 		</a>

			// 	</dd>
			// </dl>`
			// })
			// $("article").append(news);
			// 	}
			// });
		}
	}
</script>

<style scoped>
	@import url("../assets/css/commen.css");
	@import url("../assets/css/newslist.css");
</style>
